import React from 'react';
import './LovableHero.css';

const LovableHero = () => {
  return (
    <section className="mc-section mc-lovable-hero">
      <h1 className="mc-ltitle mc-gradient-accent">Master the Future</h1>
      <p className="mc-lsubtitle">Five pillars of modern AI-powered development</p>

      <div className="mc-pillars-grid">
        <div className="mc-pillar-card">
          <span className="mc-pillar-icon">🤖</span>
          <h3 className="mc-pillar-title">AI Tools</h3>
        </div>
        <div className="mc-pillar-card">
          <span className="mc-pillar-icon">🎨</span>
          <h3 className="mc-pillar-title">Vibe Coding</h3>
        </div>
        <div className="mc-pillar-card">
          <span className="mc-pillar-icon">💻</span>
          <h3 className="mc-pillar-title">Smart IDEs</h3>
        </div>
        <div className="mc-pillar-card">
          <span className="mc-pillar-icon">🧠</span>
          <h3 className="mc-pillar-title">AI Agents</h3>
        </div>
        <div className="mc-pillar-card">
          <span className="mc-pillar-icon">✍️</span>
          <h3 className="mc-pillar-title">Prompt Engineering</h3>
        </div>
      </div>
    </section>
  );
};

export default LovableHero;
